export default __webpack_public_path__ + "static/5-f5952d0b505cead8a6fb8d1ba33f703d.jpg";